import styled from 'styled-components';

export const LoadingListNoticeCompany = styled.div`
  margin-top: 1rem;
  width: 106.25rem;
  height: calc(100vh - 13rem);
  position: absolute;
  background: rgb(255, 255, 255, 0.8);
  z-index: 5;
  display: flex;
  align-items: center;
`;
